import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
  selector: 'page-sub-status-history',
  templateUrl: 'sub-status-history.html',
})
export class SubStatusHistoryPage {


  SubStatusData:any;
  FWebEnquiryId:any;
  datanotfound:any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public service:ServiceProvider,
              public platform:Platform,
              public viewCtrl:ViewController) {
    this.platform.ready().then(() => {
      this.FWebEnquiryId=navParams.get('FWebEnquiryId');
      this.loadValues(this.FWebEnquiryId);
    })

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SubStatusHistoryPage');
  }

    dismiss() {
        this.viewCtrl.dismiss();
    }

  loadValues(FWebEnquiryId){
    this.service.httpcall('web_service/getSubStatus_log_by_FWebEnquiryId?FWebEnquiryId=' +FWebEnquiryId ).subscribe(data => {

          console.log(data);
          if(data['response']=="success"){
            this.SubStatusData=data['data'];
          }else{
            this.datanotfound=data['error_description'];
          }
        })
  }

}



// WEBPACK FOOTER //
// ./src/pages/sub-status-history/sub-status-history.ts